import React from 'react';
import ReactDOM from 'react-dom/client';
import App from './App';
import './styles/variables.css';  
import './styles/global.css';     
import './styles/mediaQueries.css';
import { ThemeProvider } from './context/ThemeContext';
import { DeviceProvider } from './context/DeviceContext';
import { GlobalErrorProvider } from './context/GlobalErrorContext';


const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <React.StrictMode>
    <GlobalErrorProvider>
      <ThemeProvider>
        <DeviceProvider>
          <App />
        </DeviceProvider>
      </ThemeProvider>
    </GlobalErrorProvider>
  </React.StrictMode>
);
